<p-accordion [value]="0">
  <p-accordion-panel [value]="0">
    <p-accordion-header>Filtros de Pesquisa</p-accordion-header>
    <p-accordion-content>
      <div class="my-4">
        <form method="GET" action="/events" class="text-blueGray-700 space-y-4" [formGroup]="form"
              (ngSubmit)="submitForm()">

          <div class="auto space-y-8 text-blueGray-700 text-xs">

            <div class="lg:hidden">
            <app-select-input
              [formGroup]="form"
              id="category"
              [options]="categories"
              label="Categoria"
              wrapperClass="mb-4"
              (onChange)="selectCategory($event.value)">
            </app-select-input>
            </div>

            <div>
            <app-select-input
              [formGroup]="form"
              id="intent"
              [options]="intents"
              label="Intenção"
              wrapperClass="mb-4">
            </app-select-input>
            </div>

            <div>
            <app-text-input [formGroup]="form" [value]="form.value?.reward"
                            [maxLength]="15" id="reference" label="Referencia"
            ></app-text-input>
            </div>

            <div>
            <app-text-input [formGroup]="form" id="title" label="Nome/Título"></app-text-input>
            </div>

            <div>
            <app-text-input *ngIf="category !== 'pessoa' && category !== 'veiculo'"
              [formGroup]="form" id="identification" label="Identificação"></app-text-input>
            </div>

            <ng-container *ngIf="category === 'PEOPLE'">
              <div>
              <app-select-input
                [formGroup]="form"
                id="gender"
                [options]="genders"
                label="Gênero (Obrigatório)"
                wrapperClass="mb-4">
              </app-select-input>
              </div>

              <div>
              <app-text-input [formGroup]="form" type="number" id="minAge" label="Idade mínima"></app-text-input>
              </div>

              <div>
              <app-text-input [formGroup]="form" type="number" id="maxAge" label="Idade máxima"></app-text-input>
              </div>
            </ng-container>

            <ng-container *ngIf="category === 'DOCUMENT'">
              <div>
              <app-select-input
                [formGroup]="form"
                id="documentType"
                [options]="documentType"
                label="Tipo do Documento"
                wrapperClass="mb-4">
              </app-select-input>
              </div>

              <div>
              <app-text-input [formGroup]="form" id="documentEntity"
                label="Entidade Emissora"></app-text-input>
              </div>
            </ng-container>

            <ng-container *ngIf="category === 'VEHICLE'">
              <div>
              <app-text-input [formGroup]="form" id="brand" label="Marca do Veículo"></app-text-input>
              </div>
              <div>
              <app-text-input [formGroup]="form" id="model" label="Modelo do Veículo"></app-text-input>
              </div>
              <div>
              <app-text-input [formGroup]="form" id="licensePlate" label="Matrícula"></app-text-input>
              </div>
              <div>
              <app-text-input [formGroup]="form" id="chassiNumber" label="número do chassi"></app-text-input>
              </div>
            </ng-container>

            <div>
            <app-calendar-input
              [formGroup]="form"
              id="eventDate"
              label="Data da Ocorrência"
              [maxDate]="eventMaxDate"
              [touchUI]="true">
            </app-calendar-input>
            </div>

            <div>
            <app-select-input
              [formGroup]="form"
              id="province"
              [options]="provinces"
              label="Província"
              wrapperClass="mb-4">
            </app-select-input>
            </div>

          </div>

          <div class="flex space-x-2">
            <app-ae-button variant="primary" icon="pi pi-search" type="submit" label="Pesquisar"
              size="sm" styleClass="text-xs"></app-ae-button>

            <app-ae-button variant="plain" label="Limpar" size="sm" styleClass="text-xs"
              (buttonClick)="onClear()"></app-ae-button>
          </div>
        </form>
      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
